<script>
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {computed, onMounted, ref, watch} from "vue";
import StrCatalogAutocomplete from "@/views/Training/Catalog/Components/StrCatalogAutocomplete.vue";
import axios from "axios";
import useSharedSelectData from "@/use/SharedSelectData";
import useSharedData from "@/use/SharedData";
import useValidation from "@/use/Validation";

export default {
    components: {StrCatalogAutocomplete},
    props: {
        value: Object,
        readonly: Boolean,
        type: String,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();
        const {$refs} = useTools();
        const {mxRules} = useValidation();
        const {formatedDate, formatedTime} = useSharedMethod();
        const {recruitmentEvaluationDecisions} = useSharedSelectData();

        const evaluationInterview = ref({
            preSelectedNote: true,
            activateCategoryGravity: true,
            activateCriterionGravity: false,
            activateTarget: false,
            note: 0,
            categories: [],
            questions: [],
            closed: false,
        });

        const categoryColspan = computed(() => {
            let num = 1;
            if (evaluationInterview.value.activateCategoryGravity)
                num++;

            if (evaluationInterview.value.hideCategoryNote)
                num--;

            return num;
        });

        const colspan = computed(() => {
            let num = 3;

            if (evaluationInterview.value.activateCriterionGravity)
                num++;

            if (evaluationInterview.value.activateTarget)
                num++;

            if (evaluationInterview.value.hideCriterionNote)
                num--;

            if (props.type === 'EVALUATION_PERFORMANCE')
                num += 2;

            return num;
        });

        const gravities = ref([]);
        const gravityDialog = ref(false);

        function findAllGravities() {
            axios.get(`/evaluationGravities`, {params: {type: props.type}}).then(response => {
                gravities.value = response.data;
            });
        }

        const selectedCriterion = ref({});
        const selectedCategory = ref({criteria: []});

        function selectCriterionAndCategory(criterion, category) {
            selectedCriterion.value = criterion;
            selectedCategory.value = category;
            gravityDialog.value = true;
        }

        function setGravity(gravity) {
            selectedCriterion.value.gravityId = gravity.id;
            selectedCriterion.value.gravityName = gravity.name;
            selectedCriterion.value.gravityNote = gravity.note;

            calculate();

            gravityDialog.value = false;
        }

        function calculate() {
            if (!props.readonly && !evaluationInterview.value.disallowCriterionUpdate) {
                axios.post('/evaluationInterviews/calculate', evaluationInterview.value).then(response => {
                    evaluationInterview.value = response.data;
                });
            }
        }


        const selectedQuestion = ref({});
        const questionDialog = ref(false);

        function selectQuestion(question) {
            selectedQuestion.value = question;
            questionDialog.value = true;
            $refs.questionForm.reset();
        }

        watch(() => props.value, () => {
            evaluationInterview.value = props.value;
        }, {deep: true, immediate: true});

        watch(() => evaluationInterview.value, () => {
            emit('input', evaluationInterview.value);
        }, {deep: true, immediate: true});

        onMounted(() => {
            findAllGravities();
        });

        return {
            mxRules,
            evaluationInterview,
            gravities,
            gravityDialog,
            selectedCriterion,
            selectedQuestion,
            questionDialog,
            recruitmentEvaluationDecisions,
            categoryColspan,
            colspan,
            inputColor,
            backgroundColor,
            formatedDate,
            formatedTime,
            selectQuestion,
            selectCriterionAndCategory,
            setGravity,
            calculate
        };
    }
}
</script>

<template>
    <div>


        <w-fieldset title="Sections">
            <v-simple-table dense class="myTable">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th
                            class="text-center"
                            :colspan="categoryColspan + 1"
                            style="background-color: #f5f5f5"
                        >
                            <strong>Section</strong>
                        </th>
                        <th
                            class="text-center"
                            :colspan="colspan"
                            style="background-color: #f5f5f5"
                        >
                            <strong></strong>
                        </th>
                    </tr>
                    <tr>
                        <th
                            class="text-center"
                            style="background-color: #f5f5f5"
                        >
                            Section
                        </th>
                        <th
                            class="text-center"
                            v-if="evaluationInterview.activateCategoryGravity"
                            style="background-color: #f5f5f5"
                        >
                            Pondération (%)
                        </th>
                        <th
                            class="text-center"
                            v-if="!evaluationInterview.hideCategoryNote"
                            style="background-color: #f5f5f5"
                        >
                            Score Section
                        </th>
                        <th
                            class="text-center"
                            style="background-color: #f5f5f5"
                        >
                            {{ $t(`evaluation.criterion_name_${type}`) }}
                        </th>
                        <th
                            v-if="type === 'EVALUATION_PERFORMANCE'"
                            class="text-center"
                            style="background-color: #f5f5f5"
                        >
                            {{ $t('common.kpi') }}
                        </th>
                        <th
                            v-if="type === 'EVALUATION_PERFORMANCE'"
                            class="text-center"
                            style="background-color: #f5f5f5"
                        >
                            {{ $t('common.deadline') }}
                        </th>
                        <th
                            class="text-center"
                            style="background-color: #f5f5f5"
                        >
                            Réalisé
                        </th>

                        <th
                            class="text-center"
                            v-if="evaluationInterview.activateTarget"
                            style="background-color: #f5f5f5"
                        >
                            Cible
                        </th>
                        <th
                            class="text-center"
                            v-if="evaluationInterview.activateCriterionGravity"
                            style="background-color: #f5f5f5"
                        >
                            Pondération (%)
                        </th>
                        <th
                            class="text-center"
                            v-if="!evaluationInterview.hideCriterionNote"
                            style="background-color: #f5f5f5"
                        >
                            Score
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(category, indez) in evaluationInterview.categories">
                        <template v-for="(criterion, index) in category.criteria">
                            <tr :key="`cc-${indez}-${index}`" class="border-b border-gray-200 hover:bg-gray-50">
                                <td
                                    v-if="index === 0"
                                    class="text-center"
                                    :rowspan="category.criteria.length"
                                >
                                    <w-inline-text bold :text="category.name"/>
                                </td>
                                <td
                                    v-if="index === 0 && evaluationInterview.activateCategoryGravity"
                                    class="text-center"
                                    :rowspan="category.criteria.length"
                                >
                                    <strong>{{ category.gravity }}</strong>
                                </td>
                                <td
                                    v-if="index === 0  && !evaluationInterview.hideCategoryNote"
                                    class="text-center"
                                    style="background-color: #E0F2F1"
                                    :rowspan="category.criteria.length"
                                >
                                    <strong>{{ category.weightedNote }}</strong>
                                </td>
                                <td>
                                    <w-inline-text disable-inline :text="criterion.name"/>
                                    <w-btn-icon-help :text="criterion.notes"/>
                                </td>
                                <td v-if="type === 'EVALUATION_PERFORMANCE'">
                                    <w-inline-text disable-inline :text="criterion.keyPerformanceIndicator"/>
                                </td>
                                <td v-if="type === 'EVALUATION_PERFORMANCE'">
                                    <w-chip outlined :text="criterion.deadline"/>
                                </td>
                                <td class="text-center" style="">
                                    <w-chip
                                        v-if="evaluationInterview.preSelectedNote"
                                        :text="criterion.gravityName ? criterion.gravityName : $t('evaluation.click_to_chose')"
                                        :readonly="readonly || evaluationInterview.disallowCriterionUpdate"
                                        outlined
                                        icon="mdi-pencil"
                                        icon-color="orange"
                                        @press="selectCriterionAndCategory(criterion, category)"
                                    />

                                    <w-edit-dialog
                                        v-else
                                        v-model="criterion.gravityNote"
                                        :readonly="readonly || evaluationInterview.disallowCriterionUpdate || category.distribution === 'COMMON'"
                                        hide-details
                                        type="number"
                                        @save="calculate"
                                    />

                                </td>
                                <td
                                    v-if="evaluationInterview.activateTarget"
                                    class="text-center"
                                    style=""
                                >
                                    <w-chip
                                        v-if="evaluationInterview.preSelectedNote"
                                        label
                                        outlined
                                        :text="criterion.targetByGravityName"
                                    />
                                    <strong v-else>{{ criterion.target }}</strong>
                                </td>
                                <td
                                    v-if="evaluationInterview.activateCriterionGravity"
                                    class="text-center"
                                >
                                    <strong>{{ criterion.gravity }}</strong>
                                </td>
                                <td
                                    v-if="!evaluationInterview.hideCriterionNote"
                                    class="text-center"
                                    style="background-color: #E0F2F1"
                                >
                                    <strong>{{ criterion.weightedNote.toFixed(2) }}</strong>
                                </td>
                            </tr>
                        </template>
                        <!-- Spacing row after each category -->
                        <tr v-if="indez < evaluationInterview.categories.length - 1" :key="`spacer-${indez}`">
                            <td colspan="100%" style="height: 10px;"></td>
                        </tr>
                    </template>
                    <tr v-if="!evaluationInterview.hideNote">
                        <td
                            :colspan="categoryColspan"
                            class="text-center"
                            style="background-color: #f5f5f5"
                        >
                            <strong>Score Finale</strong>
                        </td>
                        <td
                            class="text-center white--text"
                            style="background-color: #009688"
                        >
                            <h2>
                                <w-inline-text :text="`${evaluationInterview.note} %`"/>
                            </h2>
                        </td>
                        <td
                            :colspan="colspan"
                            class="text-center"
                        >
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </w-fieldset>
        <br/>
        <w-fieldset :title="$t('common.questions')">
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-start" style="width: 50%">{{ $t('common.question') }}</th>
                        <th class="text-end">{{ $t('common.response') }}</th>
                        <th class="text-start"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(item, index) in evaluationInterview.questions">
                        <tr :key="`question-${index}`">
                            <td class="text-start">{{ item.question }}</td>
                            <td class="text-end">
                                <span v-if="item.type === 'NUMBER'">
                                    {{ item.number }}
                                </span>
                                <span v-if="item.type === 'DATE'">
                                    {{ formatedDate(item.date) }}
                                </span>
                                <span v-if="item.type === 'TIME'">
                                   {{ formatedTime(item.time) }}
                                </span>
                                <span v-if="item.type === 'DATE_TIME'">
                                    {{ `${formatedDate(item.date)} ${formatedTime(item.time)}` }}
                                </span>
                                <span v-if="item.type === 'TEXT'">
                                    {{ item.text }}
                                </span>
                                <span
                                    v-if="(item.type === 'TRUE_FALSE' ||item.type === 'TRUE_FALSE_WITH_EXPLAIN') && item.trueFalse !== null">
                                    {{ $t(`pay_section.boolean_${item.trueFalse}`) }}
                                </span>
                                <span v-if="item.type === 'SELECT' || item.type === 'SELECT_TYPE'">
                                    {{ item.selectText }}
                                </span>
                                <span v-if="item.type === 'DATE_INTERVAL'">
                                    {{
                                        `${$t('common.from')} ${formatedDate(item.startDate)} ${$t('common.to')} ${formatedDate(item.endDate)}`
                                    }}
                                </span>
                                <span v-if="selectedQuestion.type === 'TIME_INTERVAL'">
                                    {{
                                        `${$t('common.from')} ${formatedTime(item.startTime)} ${$t('common.to')} ${formatedTime(item.endTime)}`
                                    }}
                                </span>
                                <v-col cols="12" v-if="selectedQuestion.type === 'DATE_TIME_INTERVAL'">
                                </v-col>
                            </td>
                            <td class="text-start">
                                <v-btn
                                    v-if="!readonly || evaluationInterview.disallowQuestionUpdate"
                                    icon
                                    color="blue darken-2"
                                    @click="selectQuestion(item)"
                                >
                                    <v-icon>mdi-progress-question</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </template>
            </v-simple-table>
        </w-fieldset>
        <br/>
        <w-fieldset :title="'Autre'">
            <v-row dense v-if="type === 'EVALUATION_SKILL'">
                <v-col cols="12">
                    <w-label :label="$t('evaluation.proposed_theme')"/>
                    <str-catalog-autocomplete
                        v-model="evaluationInterview.catalogIds"
                        multiple
                        :readonly="readonly"
                        :disabled="evaluationInterview.other"
                    />
                </v-col>
                <!--<v-col cols="12">
                    <v-checkbox
                        v-model="evaluationInterview.other"
                        :readonly="readonly"
                        hide-details
                        class="mt-n1"
                        :label="$t('training.other_catalog')"
                    />
                </v-col>
                <v-col cols="12" v-if="evaluationInterview.other">
                    <w-text-field
                        v-model="evaluationInterview.otherDescription"
                        :readonly="readonly"
                        :rules="[mxRules.required]"
                    />
                </v-col>-->
            </v-row>
            <v-row dense v-if="type === 'EVALUATION_RECRUITMENT'">
                <v-col cols="12">
                    <strong>Decision *</strong>
                    <w-enum-select
                        v-model="evaluationInterview.decision"
                        :items="recruitmentEvaluationDecisions"
                        :readonly="readonly"
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <w-label :label="$t('common.observation')"/>
                    <w-simple-text-area
                        v-model="evaluationInterview.description"
                        :readonly="readonly"
                    />
                </v-col>
            </v-row>
        </w-fieldset>

        <v-dialog
            v-model="gravityDialog"
            max-width="600"
            scrollable
        >
            <v-card>
                <w-toolbar color="red" :title="$t('module.evaluation_gravities')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-list dense>
                            <template v-for="(gravity, index) in gravities">
                                <v-list-item
                                    :key="`gravity-${index}`"
                                    @click="setGravity(gravity)"
                                    two-line
                                >
                                    <v-list-item-content>
                                        <v-list-item-title>{{ gravity.name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ gravity.description }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon color="teal" v-if="gravity.id === selectedCriterion.gravityId">
                                            mdi-check-circle
                                        </v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider :key="`d-gravity-${index}`"/>
                            </template>
                        </v-list>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="questionDialog"
            max-width="900"
            scrollable
        >
            <v-card>
                <w-toolbar color="red" :title="$t('common.question')"/>
                <v-card-text>
                    <v-container fluid>
                        <v-form ref="questionForm" lazy-validation>
                            <v-row dense>
                                <v-col cols="12">
                                    <h3>
                                        <v-icon large color="red">mdi-progress-question</v-icon>
                                        {{ selectedQuestion.question }}
                                    </h3>
                                </v-col>
                                <v-col cols="12" v-if="selectedQuestion.type === 'NUMBER'">
                                    <w-text-field
                                        v-model="selectedQuestion.number"
                                        type="number"
                                    />
                                </v-col>
                                <v-col cols="6" v-if="selectedQuestion.type === 'DATE'">
                                    <w-date-picker v-model="selectedQuestion.date"/>
                                </v-col>
                                <v-col cols="6" v-if="selectedQuestion.type === 'TIME'">
                                    <w-time-picker v-model="selectedQuestion.time"/>
                                </v-col>
                                <v-col cols="12" v-if="selectedQuestion.type === 'DATE_TIME'">
                                    <v-row dense>
                                        <v-col cols="6">
                                            <w-date-picker v-model="selectedQuestion.date"/>
                                        </v-col>
                                        <v-col cols="6">
                                            <w-time-picker v-model="selectedQuestion.time"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" v-if="selectedQuestion.type === 'TEXT'">
                                    <w-simple-text-area v-model="selectedQuestion.text"/>
                                </v-col>
                                <v-col cols="12"
                                       v-if="selectedQuestion.type === 'TRUE_FALSE' || selectedQuestion.type === 'TRUE_FALSE_WITH_EXPLAIN'">
                                    <v-radio-group v-model="selectedQuestion.trueFalse" row>
                                        <v-radio :value="true" label="Oui"/>
                                        <v-radio :value="false" label="Non"/>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12"
                                       v-if="selectedQuestion.type === 'SELECT' || selectedQuestion.type === 'SELECT_TYPE'"
                                >
                                    <v-radio-group
                                        v-model="selectedQuestion.selectText"
                                        class="mt-n2"
                                    >
                                        <v-radio
                                            v-for="item in selectedQuestion.selections"
                                            :key="item.name"
                                            :value="item.name"
                                            :label="item.name"
                                        />
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" v-if="selectedQuestion.type === 'DATE_INTERVAL'">
                                    <v-row dense>
                                        <v-col cols="6">
                                            <strong>{{ $t('common.from') }}</strong>
                                            <w-date-picker v-model="selectedQuestion.startDate"/>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>{{ $t('common.to') }}</strong>
                                            <w-date-picker v-model="selectedQuestion.endDate"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" v-if="selectedQuestion.type === 'TIME_INTERVAL'">
                                    <v-row dense>
                                        <v-col cols="6">
                                            <strong>{{ $t('common.from') }}</strong>
                                            <w-time-picker v-model="selectedQuestion.startTime"/>
                                        </v-col>
                                        <v-col cols="6">
                                            <strong>{{ $t('common.to') }}</strong>
                                            <w-time-picker v-model="selectedQuestion.endTime"/>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" v-if="selectedQuestion.type === 'DATE_TIME_INTERVAL'"></v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <input type="hidden"/>
    </div>
</template>

<style scoped>

.myTable {
    border-collapse: collapse;
    border: 1px solid #c5c5c5;
}

.myTable th,
.myTable td {
    border: 1px solid #c5c5c5;
}
</style>